import * as type from '../constants/modal';

export function show(modalType = '', modalProps = {}) {
    return {
        modalProps,
        modalType,
        type: type.SHOW_MODAL,
    };
}

export function hide() {
    return {
        type: type.HIDE_MODAL,
    };
}

